module.exports = __webpack_public_path__ + "media/src/images/icons/olympinfo/olympinfo-team-be906dacc2a0305b1653ce77f38cf060.svg";